import { Component, OnInit, inject, Inject, afterNextRender } from '@angular/core';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDataService } from '../../shared/services/userData.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'building',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './building.component.html',
  styleUrl: './building.component.css'
})
export class BuildingComponent implements OnInit {
  // DI via field injectors (valid injection context)
  private readonly router = inject(Router);
  private readonly route  = inject(ActivatedRoute);
  private readonly platformId: object = inject(PLATFORM_ID);

  buildingId: string | null = null;
  hasAssess: string = '0'; // Default to '0' (no assessment)
  orgType: string = '1'; // Default to '1' (K-12)

  constructor(private userDataService: UserDataService) {}

  ngOnInit(): void {
    // Runs on SSR and CSR. Do NOT navigate here.
    this.route.paramMap.subscribe((params) => {
      this.buildingId = params.get('buildingId');
      this.hasAssess  = params.get('hasAssess') ?? '0'; // Default to '0' if null
      this.orgType    = params.get('orgType') ?? '1'; // Default to '1' if null

      // Persist state in service (safe on SSR)
      if (this.buildingId) {
        this.userDataService.setBuildingId(this.buildingId);
      }
      this.userDataService.setAssessStatus(this.hasAssess);
      this.userDataService.setOrgType(this.orgType);

      // Browser-only persistence
      if (isPlatformBrowser(this.platformId) && this.buildingId) {
        localStorage.setItem('rems_eop_building_id', this.buildingId);
      }
    });
  }

  // Schedule redirect ONLY after the next render on the client.
  // Field initializer runs in an injection context, so no NG0203.
  private readonly _postRenderRedirect = afterNextRender(() => {
    if (!isPlatformBrowser(this.platformId)) return;

    const id = this.route.snapshot.paramMap.get('buildingId');
    if (id) {
      this.router.navigateByUrl('/');
    }
  });
}
